module.exports = __webpack_public_path__ + "img/chevron_claro.2da9cde5.svg";